import { ErrorBaseData } from '.'

export const attendanceShareTokenErrors: Record<string, ErrorBaseData> = {
  AttendanceShareTokenAlreadyUsedException: {
    message: 'Token já usado',
    description: 'Este token de atendimento já foi utilizado',
  },
  AttendanceShareTokenNotFoundException: {
    message: 'Token não encontrado',
    description: 'Não foi possível encontrar o token de atendimento. Verifique as informações e tente novamente',
  },
  CannotCreateAttendanceShareTokenException: {
    message: 'Erro ao criar token de atendimento',
    description: 'Não foi possível criar o token de atendimento. Verifique as informações e tente novamente',
  },
}
